import { FormHelperText, TextFieldProps } from '@/primitives';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers-pro';

type TOwnProps = DatePickerProps & {
  error?: TextFieldProps['error'];
  helperText?: TextFieldProps['helperText'];
  required?: TextFieldProps['required'];
  variant?: TextFieldProps['variant'];
};

export const DatePickerPro = (props: TOwnProps) => {
  const { variant, required, error, helperText, ...rest } = props;

  const textFieldSlot =
    props.slotProps?.textField && typeof props.slotProps.textField === 'object'
      ? props.slotProps.textField
      : undefined;
  const inputPropsSxFromSlot =
    textFieldSlot?.InputProps &&
    typeof textFieldSlot.InputProps === 'object' &&
    'sx' in textFieldSlot.InputProps
      ? textFieldSlot.InputProps.sx
      : undefined;

  const renderError = () => {
    return (
      error &&
      helperText && (
        <FormHelperText error={error} sx={{ marginLeft: '14px' }}>
          {helperText}
        </FormHelperText>
      )
    );
  };

  if (variant === 'filled') {
    return (
      <>
        <DatePicker
          {...rest}
          slotProps={{
            ...props.slotProps,
            textField: {
              ...props.slotProps?.textField,
              error,
              required: props.required,
              variant: props.variant as 'standard' | undefined,
              InputLabelProps: {
                shrink: true,
                sx: {
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  lineHeight: '20px',
                  letterSpacing: '0.25px',
                  paddingTop: '3px',
                  paddingLeft: '1px',
                },
              },
              InputProps: {
                disableUnderline: true,
                sx: {
                  bgcolor: 'background.paper',
                  borderRadius: '8px',
                  border: '1px solid',
                  borderColor: 'divider',
                  ':focus-within': {
                    borderColor: 'primary.main',
                  },
                  ':has(input[aria-invalid="true"])': {
                    borderColor: 'error.main',
                  },
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '20px',
                  letterSpacing: '0.25px',
                  '.Mui-disabled': {
                    borderRadius: '8px',
                    fontStyle: 'italic',
                    cursor: 'default',
                    '& input, & .MuiPickersInputBase-sectionsContainer, & .MuiPickersSectionList-section':
                      {
                        cursor: 'default',
                      },
                  },
                  ...inputPropsSxFromSlot,
                  '& .MuiInputAdornment-positionEnd': {
                    paddingRight: '8px',
                  },
                  '& .MuiInputAdornment-root .MuiIconButton-root': {
                    padding: '6px',
                  },
                  '& .MuiInputAdornment-root .MuiSvgIcon-root': {
                    fontSize: '1.25rem',
                  },
                },
              },
            },
          }}
        />
        {renderError()}
      </>
    );
  }

  return (
    <>
      <DatePicker
        {...rest}
        slotProps={{
          textField: {
            required,
            variant,
          },
        }}
      />
      {renderError()}
    </>
  );
};
